import React from 'react'

interface Props {
  number: number;
  total: number;
}

export const Step: React.FC<Props> = ({ number, total }) => {
  return (
    <div className='mb-[30px]'>
      <span className='font-bold color-secondary text-[12px]'>
        {number.toString().padStart(2, '0')}
      </span>
      <div className='flex mt-[5px]'>
        {Array.from({ length: total }).map((_, idx) => (
          <span
            key={idx}
            className={`w-[20px] h-[4px] rounded-[5px] ${
              idx < number
                ? 'bg--brown'
                : 'bg-[#a3a3a3] opacity-[0.25]'
            }${idx > 0 ? ' ml-[4px]' : ''}`}
          />
        ))}
      </div>
    </div>
  )
}
